export const formatSuccessRate = (rate?: number): string => (rate ? `${((rate / 100) * 5).toFixed(1)}` : 'N/A');

export const getReferralUrl = (source: string): string => process.env.REACT_APP_REFERRAL_URL + '?source=' + source;

export const getSourceUrl = (source: string): string =>
  window.location.protocol + '//' + window.location.host + '/?source=' + source;
